import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Stack } from "@mui/material";
import "./layout.scss";
import Footer from "../components/footer/Footer";
import AllRoutes from "../components/allRoutes/allRoutes";
import Alert from "../services/alerts/Alert";
import Header from "../components/Comman/header/Header";
import Sidebar from "../components/Comman/sidebar/Sidebar";
import SpeedDailComp from "../components/Comman/speedDail";
import { useLocation } from "react-router-dom";

const Layout = () => {
	const { isAuthenticated } = useSelector((state) => state?.authReducer);
	const [showSidebar, setShowSidebar] = useState(true); // default to true
	const location = useLocation();

	const handleToggleSidebar = () => {
		setShowSidebar((prev) => !prev);
	};

	const gridStyle = {
		marginTop: isAuthenticated ? `${showSidebar ? "10%" : "13%"}` : "0%",
		marginLeft: isAuthenticated ? `${showSidebar ? "20%" : "3%"}` : "0%",
		transition: "margin 0.3s ease-in-out",
	};

	return (
		<div>
			{isAuthenticated && <Header toggleSidebar={handleToggleSidebar} showSidebar={showSidebar} />}
			{isAuthenticated && showSidebar && <Sidebar />}
			<Stack style={gridStyle} spacing={8}>
				<AllRoutes />
				{isAuthenticated && (
					<Footer showSidebar={showSidebar} />)}
			</Stack>
		</div>
	);
};

export default Layout;
